/**
 * Adresse publique de l'assistant (`/email-templates/ai/new?type=<code>&style=<code>&name=<nom>`, liens du site comme
 * la page « Calendrier marketing ») → page de création avec l'assistant ouvert. Seuls le type, le style et le nom sont
 * repris, nettoyés : le reste de la chaîne (UTM…) n'a rien à faire dans l'app.
 */
const CODE = /^[a-z0-9_]{1,60}$/;

/** Nom d'e-mail pré-rédigé : texte simple, sans balise ni caractère de contrôle, 100 caractères au plus. */
export const EMAIL_NAME_MAX = 100;

/**
 * Caractères retirés du nom : balises, contrôles C0 et C1, et caractères invisibles ou de direction (zéro-largeur,
 * marques et surcharges bidi) qui permettraient d'afficher un nom trompeur.
 */
const UNSAFE_NAME_CHARS = /[<>\u0000-\u001F\u007F-\u009F\u200B-\u200F\u202A-\u202E\u2066-\u2069]/g;

export function cleanEmailName(raw: string | null | undefined): string {
    const name = (raw ?? "").replace(UNSAFE_NAME_CHARS, " ").replace(/\s+/g, " ").trim();

    // Coupe par points de code, pas par unités UTF-16 : un emoji en fin de nom n'est jamais cassé en deux.
    return Array.from(name).slice(0, EMAIL_NAME_MAX).join("").trim();
}

export function cleanCode(raw: string | null | undefined): string | null {
    const code = raw?.trim() ?? "";

    return CODE.test(code) ? code : null;
}

export function aiAssistantCreatePath(search: string): string {
    const query = new URLSearchParams(search);
    const params = new URLSearchParams({ assistant: "1" });
    const type = cleanCode(query.get("type"));
    const style = cleanCode(query.get("style"));
    const name = cleanEmailName(query.get("name"));
    if (type) params.set("type", type);
    if (type && style) params.set("style", style);
    if (name) params.set("name", name);

    return `/email-templates/create?${params.toString()}`;
}
